module.exports = __webpack_public_path__ + "assets/img/blockchain_function_24px.85ef68c3.svg";